import axios, { AxiosResponse, isAxiosError } from "axios";
import { Paginated, RequestError } from "./api";

const url = `${process.env.REACT_APP_URL}/controle`;

export interface Controle {
  id: number;
  nome: string;
  descricao: string;
  localizacao: string;
  supervisorios: string;
  telefones: string;
  funcionamento: number;
  freqInspecao: number;
  instrumentos: string;
  dataCadastro: Date;
  dataModificacao?: Date;
  idUpdate?: string;
}

const get = async (idBarragem: number): Promise<Controle | RequestError | null> => {
  try {
    const data: AxiosResponse<Controle | null> = await axios.get(`${url}/${idBarragem}`);
    if (!data.data) return data.data;

    return processData(data.data);
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Erro",
        message: error.response?.data.message ?? "Erro ao obter sala de controle",
      };
    } else {
      throw error;
    }
  }
};

const update = async (
  idBarragem: number,
  constrole: Controle,
): Promise<Controle | RequestError> => {
  try {
    const data: AxiosResponse<Controle> = await axios.put(`${url}/${idBarragem}`, constrole);
    return processData(data.data);
  } catch (error) {
    if (isAxiosError(error)) {
      return {
        error: error.response?.data.error ?? "Erro",
        message: error.response?.data.message ?? "Erro ao adicionar ou atualizar sala de controle",
      };
    } else {
      throw error;
    }
  }
};

function processData(value: Controle) {
  value.dataCadastro = new Date(value.dataCadastro);
  value.dataModificacao &&= new Date(value.dataCadastro);
  return value;
}

export const ApiControle = {
  get,
  update,
};
